// @flow
import React, { Component } from 'react';
import { Link, NavLink, Redirect, Route } from 'react-router-dom';
import { Dropdown, Button, Grid, Icon, Label, Menu, Sidebar } from 'semantic-ui-react';
import { assign, first, groupBy, keys, uniqBy, uniq, flatten } from 'lodash';
import { parse, stringify } from 'query-string';
import { getAlerts, getDashboards, getGrids, getReports } from '../../modules/client';
import SubMenu from './SubMenu';
import SubMenuWithData from './SubMenuWithData';
import type { Match, Location } from 'react-router-dom';
import { PLATFORM_URL, IS_BETA, REPORTING_API } from '../../modules/consts';

export default function HeaderMenu(props: {
    dashboards: Dashboard[],
    reports: Report[],
    grids: Grid[],
    expanded: boolean,
    location: Location,
    onChangeClient: Guid => void,
    onGetDashboards: Guid => Promise<Dashboard[]>,
    onGetReports: Guid => Promise<void>,
    onGetGrids: Guid => Promise<void>,
    onHide: () => void,
    onNavigate: string => void,
    user: {
        clients: { clientId: Guid, name: string }[],
        isAdmin: Guid[]
    },
    visible: boolean
}) {
    const menuStyle = {
        borderRadius: 0, // no border
        display: 'flex',
        maxWidth: '260px',
        margin: 0
    };
    const selectedClientId = parse(props.location.search).clientId;
    const dashboardCategory = uniq(props.dashboards.map(dashboard => dashboard.categoryName));
    const to = (pathname, query) => {
        const currentQuery = parse(props.location.search);
        return assign({}, props.location, {
            pathname: pathname,
            search: stringify(assign({}, currentQuery, query))
        });
    };
    const menuItems = dashboardCategory.map(category => (
        <Menu.Item
            as={NavLink}
            content={category}
            key={category}
            onClick={() => props.onHide && props.onHide()}
            to={to('/dashboards', { category: category })}
        />
    ));

    return (
        <Sidebar
            animation="push"
            as={Menu}
            borderless
            color="blue"
            inverted
            onHide={props.onHide || (() => {})}
            size="massive"
            style={menuStyle}
            vertical
            visible={props.visible}
        >
            <Dropdown
                item
                onChange={(e, data) => {
                    props.onChangeClient(data.value);
                    if (props.onHide) props.onHide();
                }}
                options={props.user.clients.map(el => ({ text: el.name, value: el.clientId }))}
                scrolling={props.user.clients.length > 5}
                search={props.user.clients.length > 5}
                text={first(props.user.clients.filter(el => el.clientId === selectedClientId)).name}
            />
            {menuItems}
            <div style={{ flex: 1 }} />
            <Menu.Item as="a" href={PLATFORM_URL}>
                <Icon name="sign out" />
                {'Platform'}
            </Menu.Item>
        </Sidebar>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/HeaderMenu.jsx